import { CommunityViewPrivate } from "@bbb/model";
import { parseCommunityAdminSection } from "./routing";

export function resolveManagedCommunitySelection({
  isCommunityAdminView,
  pathname,
  communities,
  currentSelection,
}: {
  isCommunityAdminView: boolean;
  pathname: string;
  communities: CommunityViewPrivate[] | null;
  currentSelection: CommunityViewPrivate | null;
}) {
  if (!communities?.length) return null;

  const routeCommunityId = isCommunityAdminView
    ? parseCommunityAdminSection(pathname).communityId
    : undefined;

  if (routeCommunityId) {
    return (
      communities.find((community) => community.id === routeCommunityId) ?? null
    );
  }

  return (
    communities.find((community) => community.id === currentSelection?.id) ??
    communities[0]
  );
}

export function isManagedCommunityRouteReady({
  isCommunityAdminView,
  pathname,
  selectedCommunityId,
}: {
  isCommunityAdminView: boolean;
  pathname: string;
  selectedCommunityId?: string;
}) {
  if (!isCommunityAdminView) return true;

  const routeCommunityId = parseCommunityAdminSection(pathname).communityId;
  return !routeCommunityId || selectedCommunityId === routeCommunityId;
}
